/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NormativeDocumentControllerFolioStatus200ResponseDataSuggested } from './normativeDocumentControllerFolioStatus200ResponseDataSuggested';
import { NormativeDocumentControllerFolioStatus200ResponseDataFoliosInner } from './normativeDocumentControllerFolioStatus200ResponseDataFoliosInner';


export interface NormativeDocumentControllerFolioStatus200ResponseData { 
    companyId?: string;
    areaId?: string;
    typeId?: string;
    areaCode?: string;
    typeCode?: string;
    suggested?: NormativeDocumentControllerFolioStatus200ResponseDataSuggested;
    folios?: Array<NormativeDocumentControllerFolioStatus200ResponseDataFoliosInner>;
    /**
     * Huecos por debajo del mayor consecutivo ocupado. Se pueden capturar
     */
    gaps?: Array<number>;
}

